//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.VariableRadiusPointsBuilderList.js";
import "../no/ScCollector.js";
import "../Features/Features.SmoothRangeBuilderList.js";
import "../no/ScCollector.js";
import "../no/ObjectList.js";
let d=[[[1,"ControlPoint",0,"Features.VariableRadiusPointsBuilderList",0],[1,"EdgeToBlend",0,"ScCollector",0],[0,"Patch",1,0],[1,"SmoothRange",0,"Features.SmoothRangeBuilderList",0],[0,"Tolerance",1,0],[0,"Trim",1,1],[0,"TrimInputFacesToExtendedRail",1,0]],[[[],"NewControlPoint",{R_:{variableRadiusPointsBuilder:"Features.VariableRadiusPointsBuilder"}},0,0],[[],"NewSmoothRange",{R_:{smoothRangeBuilder:"Features.SmoothRangeBuilder"}},0,0]],[]];
SPLM.Features.FlowBlendBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FlowBlendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;